import { useState, useCallback, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';
import ReportNavigationComponent from '../ReportNavigationComponent/ReportNavigationComponent';
import AlertComponent from '../../core/AlertComponent/AlertComponent';
import ProgressComponent from '../../core/ProgressComponent/ProgressComponent';
import ReportPickerComponent from '../ReportPickerComponent/ReportPickerComponent';
import { fullPageReportStyles } from './FullPageReportComponent.styles';

interface FullPageReportComponentProps {
  title: string;
  component: string;
  onBackClick?: () => void;
}

export const FullPageReportComponent = ({
  title,
  component,
  onBackClick,
}: FullPageReportComponentProps) => {
  const theme = useTheme();
  const [inited, setInited] = useState(false);

  useEffect(() => {
    setInited(false);
  }, [component]);

  const handleBackClick = useCallback(() => {
    if (onBackClick) {
      onBackClick();
    } else {
      window.history.back();
    }
  }, [onBackClick]);

  const handleInited = useCallback((value?: boolean) => {
    setInited(value !== false);
  }, []);

  return (
    <Box sx={fullPageReportStyles.root(theme)}>
      <ReportNavigationComponent title={title} onBackClick={handleBackClick} />
      <AlertComponent />
      <Box sx={fullPageReportStyles.content(theme)}>
        {!inited && (
          <ProgressComponent text={`Loading ${component}`} />
        )}
        <Box sx={{ display: inited ? 'block' : 'none' }}>
          <ReportPickerComponent
            reportType={component}
            onInited={handleInited}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default FullPageReportComponent;
